// modules/house-and-land/elements/IndividualPackage.js
import React        from 'react';
import { Link }         from 'react-router'
import PackageBed   from '../../images/PackageBed';
import PackageBath   from '../../images/PackageBath';
import PackageCar   from '../../images/PackageCar';

class IndividualPackage extends React.Component {
	constructor(props) {
		super(props);
		this.clientEvent = this.clientEvent.bind(this);
	}

	formatNumber(option) {
		var formattedoption;
		if (isNaN(option)) {
			formattedoption = option;
		} else {
			formattedoption = option.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			formattedoption = '$'+ formattedoption;
		}
		return formattedoption;
	}

	clientEvent(id) {
		if (typeof this.props.changePackage !== "undefined") {
			this.props.changePackage(id);
		}
	}

	render() {
		var divImage = {
			backgroundImage : "url(" + this.props.pkdetails.p_render + ")"
		};
		var p_price = this.formatNumber(this.props.pkdetails.p_price);
		return (
			<div className="ipackage-container">
				<Link to={this.props.pkdetails.p_link} onClick={(e)=>this.clientEvent(this.props.pkdetails.p_id)}>
					<div>
						<div className="ipackage-render" style={divImage}></div>
						<div className="ipackage-details">
							<h2 className="ipackage-heading">{this.props.pkdetails.b_name}</h2>
							<h3 className="ipackage-heading">{this.props.pkdetails.p_name}</h3>
							<h4 className="ipackage-heading">from {p_price}*</h4>
							<div className="ipackage-detail-container">
								<div className="ipackage-detail bed"><PackageBed/>{this.props.pkdetails.p_beds}</div>
								<div className="ipackage-detail bath"><PackageBath/>{this.props.pkdetails.p_baths}</div>
								<div className="ipackage-detail car"><PackageCar/>{this.props.pkdetails.p_cars}</div>
								<div className="clear-div"/>
							</div>
							<div className="ipackage-more-detail-container">
								<div className="ipackage-more-detail">View this package</div>
							</div>
						</div>
					</div>
				</Link>
			</div>
		);
	}
}

export default IndividualPackage;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/IndividualPackage.js
 **/